
(function(){
  if(window.__idCur)return;window.__idCur=1;
  var G='\ue900';
  function kind(){
    var c='AED';
    try{ if(window.Shopify&&Shopify.currency&&Shopify.currency.active){c=Shopify.currency.active;} }catch(e){}
    if(c==='SAR'){return 'sar';}
    if(c==='AED'){return 'dh';}
    return null;
  }
  // Matches a currency code either BEFORE a number (group 1: "AED 219") or
  // AFTER a number (group 2 = the number: "219 SR" / "100.00 SR"). In both
  // cases the glyph is placed before the number, matching the AED side + Jarir.
  var RE=/(AED|SAR|SR|Dhs?|DH|د\.?إ|ر\.?س|﷼)\s*(?=[0-9٠-٩])|([0-9٠-٩][0-9٠-٩.,٫٬]*)\s*(?:SAR|SR|AED|Dhs?|DH|د\.?إ|ر\.?س|﷼)(?![A-Za-z0-9٠-٩])/g;
  function makeSpan(k,big){
    var s=document.createElement('span');
    s.className='idcur '+(k==='sar'?'idcur--sar':'idcur--dh');
    s.setAttribute('aria-hidden','true');
    // Inline !important so the symbol font always wins over section CSS (e.g. .id-bsc).
    s.style.setProperty('font-family', k==='sar'?'idcur-riyal':'idcur-dirham', 'important');
    s.style.setProperty('font-style','normal','important');
    // Discover Latest stays as-is (sar 1.08em, dh 1em); product pages get a bigger glyph.
    var fs = (k==='sar') ? (big?'1.3em':'1.08em') : (big?'1.2em':'');
    if(fs){ s.style.setProperty('font-size', fs, 'important'); }
    s.textContent=G;
    return s;
  }
  // For a split label (code in its own small element), size the glyph to the
  // adjacent price NUMBER so it reads at the price's prominence, not the tiny code size.
  function sizeToNumber(ce,sym){
    var host=ce.parentElement; if(!host)return;
    var amt=host.querySelector('[data-p]'), kids, i;
    if(!amt){ kids=host.children; for(i=0;i<kids.length;i++){ if(kids[i]!==ce && /[0-9٠-٩]/.test(kids[i].textContent||'')){ amt=kids[i]; break; } } }
    var fs=amt?parseFloat(getComputedStyle(amt).fontSize):0;
    if(fs){ sym.style.setProperty('font-size',(fs*0.92).toFixed(1)+'px','important'); }
  }
  var SKIP={SCRIPT:1,STYLE:1,TEXTAREA:1,SELECT:1,OPTION:1,NOSCRIPT:1,IFRAME:1};
  function skip(el){
    if(!el){return true;}
    if(SKIP[el.tagName]){return true;}
    if(el.closest&&el.closest('.idcur,[data-idcur],[data-cd-num],[data-nd-num],.aec-num'))return true;
    if(el.closest&&el.closest('[class*="localization"],form[action*="localization"],.currency-selector,.localization-form')){return true;}
    return false;
  }
  // Currency code rendered in its OWN element, split from the amount
  // (e.g. the product widget's <span class="aec-cur">SAR</span>). The text-node
  // walker can't bridge those, so swap the whole label for the glyph here.
  var CODE_ONLY=/^(?:AED|SAR|SR|Dhs?|DH|د\.?إ|ر\.?س|﷼)$/;
  function fixSplitLabels(k,onProduct,root){
    var els=[].slice.call(root.querySelectorAll('.aec-cur,.price__currency,.money-currency'));
    if(root.matches('.aec-cur,.price__currency,.money-currency'))els.unshift(root);
    for(var i=0;i<els.length;i++){
      var ce=els[i];
      if(ce.getAttribute('data-idcur')==='1'||skip(ce)){continue;}
      if(CODE_ONLY.test((ce.textContent||'').trim())){
        var big = onProduct && !(ce.closest && ce.closest('.id-bsc'));
        ce.setAttribute('data-idcur','1');
        ce.textContent='';
        var sp=makeSpan(k,big);
        ce.appendChild(sp);
        if(big){ sizeToNumber(ce,sp); }
      }
    }
  }
  function run(root){
    root=root&&root.nodeType===1?root:document.body;
    var k=kind(); if(!k){return;}
    var onProduct=document.body.classList.contains('template-product');
    fixSplitLabels(k,onProduct,root);
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{
      acceptNode:function(n){
        var v=n.nodeValue;
        if(!v||v.length>200){return NodeFilter.FILTER_REJECT;}
        if(!/[0-9٠-٩]/.test(v)){return NodeFilter.FILTER_REJECT;}
        if(skip(n.parentNode)){return NodeFilter.FILTER_REJECT;}
        RE.lastIndex=0;
        return RE.test(v)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;
      }
    });
    var hits=[],n;
    while(n=w.nextNode()){hits.push(n);}
    for(var i=0;i<hits.length;i++){
      var node=hits[i],text=node.nodeValue,frag=document.createDocumentFragment(),last=0,m;
      var big=onProduct && node.parentNode && node.parentNode.closest && !node.parentNode.closest('.id-bsc');
      RE.lastIndex=0;
      while(m=RE.exec(text)){
        if(m.index>last){frag.appendChild(document.createTextNode(text.slice(last,m.index)));}
        frag.appendChild(makeSpan(k,big));
        if(m[2]!==undefined){ frag.appendChild(document.createTextNode(m[2])); } // number-after-code: re-emit the number after the glyph
        last=m.index+m[0].length;
      }
      if(last<text.length){frag.appendChild(document.createTextNode(text.slice(last)));}
      if(node.parentNode){node.parentNode.replaceChild(frag,node);}
    }
  }
  var t,observer,roots=new Set();
  var observation={childList:true,subtree:true,characterData:true};
  function relevant(node){
    var el=node.nodeType===1?node:node.parentElement;
    if(!el||skip(el))return false;
    var text=node.textContent||'';
    RE.lastIndex=0;
    return CODE_ONLY.test(text.trim())||RE.test(text);
  }
  function queue(node){
    var el=node.nodeType===1?node:node.parentElement;
    if(!el||!el.isConnected)return;
    roots.forEach(function(old){if(el.contains(old))roots.delete(old);});
    var contained=false;roots.forEach(function(old){if(old.contains(el))contained=true;});
    if(!contained)roots.add(el);
  }
  function flush(){
    if(observer)observer.disconnect();
    roots.forEach(function(root){if(root.isConnected)run(root);});roots.clear();
    if(observer)observer.observe(document.body,observation);
  }
  function schedule(){clearTimeout(t);t=setTimeout(flush,150);}
  function initial(){queue(document.body);flush();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initial);else initial();
  try{
    observer=new MutationObserver(function(records){
      records.forEach(function(record){
        if(record.type==='characterData'){if(relevant(record.target))queue(record.target);}
        else record.addedNodes.forEach(function(node){if((node.nodeType===1||node.nodeType===3)&&relevant(node))queue(node);});
      });
      if(roots.size)schedule();
    });
    observer.observe(document.body,observation);
  }catch(e){}
  document.addEventListener('shopify:section:load',function(e){queue(e.target);flush();});
})();
